import axios from "axios";
import { OpenAPI } from "@propertelligent/client-api";

/**
 * Local client for WhatsApp feature status (GET /api/WhatsApp/enabled).
 * Kept out of generated client-api until CI regenerates the SDK.
 */

const baseUrl = (): string => (typeof OpenAPI.BASE === "string" ? OpenAPI.BASE : "");

const authHeaders = (): Record<string, string> => {
  const token = typeof OpenAPI.TOKEN === "string" ? OpenAPI.TOKEN : undefined;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getWhatsAppEnabled = async (): Promise<boolean> => {
  try {
    const res = await axios.get(`${baseUrl()}/api/WhatsApp/enabled`, { headers: authHeaders() });
    // Fail closed — only an explicit `{ enabled: true }` enables WhatsApp UI.
    return res.data?.enabled === true;
  } catch {
    // Fail closed — hide WhatsApp UI if the probe fails.
    return false;
  }
};
